export const appBackgroundGradient =
  'radial-gradient(at 20% 20%, rgba(24,45,70,0.4) 0px, transparent 60%), ' +
  'radial-gradient(at 80% 30%, rgba(53,85,111,0.4) 0px, transparent 60%), ' +
  'radial-gradient(at 40% 80%, rgba(255,130,16,0.3) 0px, transparent 60%)';

export const cssBaselineOverrides = {
  code: {
    fontFamily: '"Fira Code", monospace',
  },
  body: {
    backgroundColor: '#0A101E',
    backgroundImage: appBackgroundGradient,
    backgroundAttachment: 'fixed',
  },
};
